import React, { useContext, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "./Reviews.css";
import { Navigation } from "swiper/modules";
import { Rating } from "@smastrom/react-rating";
import "@smastrom/react-rating/style.css";
import {
  faCircleChevronLeft,
  faCircleChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CustomerLove } from "../../../../utils/apis/master/Master";
import { Context } from "../../../../utils/context";
import { CustomerLoveLuxury } from "../../../../utils/luxuryapis/master/Master";

const Reviews = () => {
  const reviewsData = [
    {
      id: 1,
      name: "Smita Lad",
      image: "/assest/luxury_images/support/peronal_care/reviews/img1.png",
      rating: 4,
      text:
        "I am happy with the product easy to handle, carry and size is perfectly comfortable.",
    },
    {
      id: 2,
      name: "Aditi Patil",
      image: "/assest/luxury_images/support/peronal_care/reviews/img2.png",
      rating: 5,
      text: "Elegant packaging and thoughtfully curated products. Loved it!",
    },
    {
      id: 3,
      name: "Neha Joshi",
      image: "/assest/luxury_images/support/peronal_care/reviews/img3.png",
      rating: 4,
      text: "Premium quality and very useful in daily life. Worth buying.",
    },
    {
      id: 4,
      name: "Pooja Deshmukh",
      image: "/assest/luxury_images/support/peronal_care/reviews/img4.png",
      rating: 5,
      text:
        "Absolutely loved the Diwali gift hamper! Made our celebration special.",
    },
    {
      id: 5,
      name: "Ritika Kulkarni",
      image: "/assest/luxury_images/support/peronal_care/reviews/img5.png",
      rating: 4,
      text: "Nice design and very comfortable to use. Highly recommended.",
    },
  ];

  const mobileReviewsData = [
    {
      id: 1,
      name: "John Doe",
      rating: 4,
      text: "Amazing service and great experience. Highly recommended!",
      image: "/assest/luxury_images/support/peronal_care/reviews/img1.png",
    },
    {
      id: 2,
      name: "Smita Lad",
      rating: 5,
      text: "Very professional team and quick support. Loved it!",
      image: "/assest/luxury_images/support/peronal_care/reviews/img2.png",
    },
    {
      id: 3,
      name: "Rahul Patil",
      rating: 4.5,
      text: "Excellent quality and customer handling.",
      image: "/assest/luxury_images/support/peronal_care/reviews/img3.png",
    },
  ];
  const { IMG_URL } = useContext(Context);
  const [dataCustomerLove, setDataCustomerLove] = useState();
  const getAllDataCustomerLove = async () => {
    const res = await CustomerLoveLuxury();
    if (res?.success) {
      setDataCustomerLove(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  useEffect(() => {
    getAllDataCustomerLove();
  }, []);
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const total = dataCustomerLove?.length || 0;

  const handleNext = () => {
    if (total <= 1) return;
    setActiveIndex((prev) => (prev + 1) % total);
  };

  const handlePrev = () => {
    if (total <= 1) return;
    setActiveIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
  };

  if (!total) return null;

  const center = dataCustomerLove[activeIndex];

  const left1 =
    total > 1 ? dataCustomerLove[(activeIndex - 1 + total) % total] : center;
  const left2 =
    total > 2 ? dataCustomerLove[(activeIndex - 2 + total) % total] : center;
  const right1 =
    total > 1 ? dataCustomerLove[(activeIndex + 1) % total] : center;
  const right2 =
    total > 2 ? dataCustomerLove[(activeIndex + 2) % total] : center;

  return (
    <>
      <section className="Reviews  desktop_view_Reviews_holder">
        <div className="custom_container">
          <h3 className="reviews_heading mt-5">Customers Love Us</h3>

          <div className="Reviews_slider_holder">
            {/* LEFT IMAGE 1 */}
            <div>
              <div className="img_holder">
                <img
                  src={IMG_URL + left1?.image}
                  alt="user"
                  className="user_img"
                />
              </div>
            </div>

            {/* LEFT IMAGE 2 */}
            <div>
              <div className="img_holder">
                <img
                  src={IMG_URL + left2?.image}
                  alt="user"
                  className="user_img"
                />
              </div>
            </div>

            {/* CENTER CARD */}
            <div className="slider_slide_card_holder">
              <div className="row">
                <div className="col-md-3">
                  <div className="img_holder">
                    <img
                      src={IMG_URL + center?.image}
                      alt="user"
                      className="user_img"
                    />
                  </div>
                </div>

                <div className="col-md-9">
                  <div className="text_holder">
                    <div style={{ width: "100%" }}>
                      <h1>{center?.name}</h1>
                      <h6>
                        Rating:
                        <Rating
                          style={{ maxWidth: 80 }}
                          value={Number(center?.ratings)}
                          readOnly
                        />
                      </h6>
                      <p>{center?.sub_name}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT IMAGE 1 */}
            <div>
              <div className="img_holder">
                <img
                  src={IMG_URL + right1?.image}
                  alt="user"
                  className="user_img"
                />
              </div>
            </div>

            {/* RIGHT IMAGE 2 */}
            <div>
              <div className="img_holder">
                <img
                  src={IMG_URL + right2?.image}
                  alt="user"
                  className="user_img"
                />
              </div>
            </div>
          </div>

          {/* NAVIGATION */}
          <div className="navigation_icon_holder">
            <FontAwesomeIcon
              className="arrow_icon"
              icon={faCircleChevronLeft}
              onClick={handlePrev}
            />
            <FontAwesomeIcon
              className="arrow_icon"
              icon={faCircleChevronRight}
              onClick={handleNext}
            />
          </div>
        </div>
      </section>

      <section className="Reviews mobile_view_Reviews_holder">
        <div className="custom_container">
          <h3 className="reviews_heading mt-5">Customers Love Us</h3>

          <div className="Reviews_slider_holder">
            <Swiper
              modules={[Navigation]}
              slidesPerView={1}
              centeredSlides={true}
              loop={true}
              spaceBetween={30}
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              breakpoints={{
                768: {
                  slidesPerView: 1,
                },
                992: {
                  slidesPerView: 1,
                },
              }}
            >
              {mobileReviewsData.map((center) => (
                <SwiperSlide key={center.id}>
                  {/* CENTER CARD */}
                  <div className="slider_slide_card_holder">
                    <div className="row me-0 ms-0">
                      <div className="col-md-3 col-sm-3 col-4 p-0">
                        <div className="img_holder">
                          <img
                            src={center.image}
                            alt="user"
                            className="user_img"
                          />
                        </div>
                      </div>

                      <div className="col-md-9 col-sm-9 col-8">
                        <div className="text_holder">
                          <div style={{ width: "100%" }}>
                            <h1>{center.name}</h1>
                            <h6>
                              Rating:
                              <Rating
                                style={{ maxWidth: 80 }}
                                value={center.rating}
                                readOnly
                              />
                            </h6>
                            <p>{center.text}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* NAVIGATION */}
          <div className="navigation_icon_holder">
            <FontAwesomeIcon
              className="arrow_icon"
              icon={faCircleChevronLeft}
              onClick={() => swiperRef.current.slidePrev()}
            />
            <FontAwesomeIcon
              className="arrow_icon"
              icon={faCircleChevronRight}
              onClick={() => swiperRef.current.slideNext()}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Reviews;
